export default __webpack_public_path__ + "static/media/text.5ee59c94.svg";